import { ApiReportSectionFieldsFieldTypeChoices } from "@api/graphql/types-and-hooks";
import { toChoiceItems, toReadableValue } from "@components/QaReview/PeerReview/peerReview.readableValue";
import { InlineDiffToken, buildInlineWordDiff } from "@components/QaReview/PeerReview/peerReview.wordDiff";

const REMOVED_CLASS_NAME = "text-red-600 line-through decoration-red-500/70";
const ADDED_CLASS_NAME = "text-emerald-700 font-medium";

const tokenClassName = (kind: InlineDiffToken["kind"]): string | undefined => {
  if (kind === "removed") return REMOVED_CLASS_NAME;
  if (kind === "added") return ADDED_CLASS_NAME;
  return undefined;
};

const BOX_CLASS_NAME =
  "rounded-md border border-limestone-200 bg-limestone-50 px-2 py-1.5 text-xs whitespace-pre-wrap text-gray-700";

const ChoiceDiff: React.FC<{ baseItems: string[]; proposedItems: string[] }> = ({ baseItems, proposedItems }) => (
  <div className={BOX_CLASS_NAME}>
    {baseItems
      .filter((item) => !proposedItems.includes(item))
      .map((item) => (
        <div key={`removed-${item}`} className={REMOVED_CLASS_NAME}>
          {item}
        </div>
      ))}
    {proposedItems
      .filter((item) => !baseItems.includes(item))
      .map((item) => (
        <div key={`added-${item}`} className={ADDED_CLASS_NAME}>
          {item}
        </div>
      ))}
  </div>
);

export const ProposedEditDiff: React.FC<{
  fieldType?: ApiReportSectionFieldsFieldTypeChoices;
  baseValue: string;
  proposedValue: string;
}> = ({ fieldType, baseValue, proposedValue }) => {
  const baseItems = toChoiceItems(fieldType, baseValue);
  const proposedItems = toChoiceItems(fieldType, proposedValue);

  if (baseItems && proposedItems) return <ChoiceDiff baseItems={baseItems} proposedItems={proposedItems} />;

  const tokens = buildInlineWordDiff(toReadableValue(fieldType, baseValue), toReadableValue(fieldType, proposedValue));
  let offset = 0;

  return (
    <div className={BOX_CLASS_NAME}>
      {tokens.map((token) => {
        const key = offset;
        offset += token.text.length;
        return (
          <span key={key} className={tokenClassName(token.kind)}>
            {token.text}
          </span>
        );
      })}
    </div>
  );
};
